<template>
  <div class="progress">
    <div class="progress__message">
      {{ message || defaultMessage }}
    </div>
    <div class="progress__track">
      <div
        class="progress__bar"
        :style="{ width: clampedPercent + '%' }"
      ></div>
    </div>
    <div class="progress__percent">{{ clampedPercent }}%</div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  interface ProgressBarProps {
    message?: string;
    defaultMessage?: string;
    percent?: number;
  }

  const props = withDefaults(defineProps<ProgressBarProps>(), {
    message: '',
    defaultMessage: '',
    percent: 0,
  });

  const clampedPercent = computed(() => {
    const value = Number.isFinite(props.percent) ? props.percent : 0;
    return Math.max(0, Math.min(100, Math.round(value)));
  });
</script>

<style scoped>
  .progress {
    margin: 24px auto;
    padding: 2px;
    width: 100%;
    max-width: 500px;
  }

  .progress__message {
    font-size: 0.9rem;
    color: #374151;
    margin-bottom: 12px;
    min-height: 1.4em;
  }

  .progress__track {
    width: 100%;
    height: 20px;
    background-color: #e5e7eb;
    overflow: hidden;
  }

  .progress .progress__bar {
    height: 100%;
    background-color: #426da9;
    transition: width 0.3s ease;
    min-width: 0;
    animation: none;
  }

  .progress__percent {
    margin-top: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #374151;
    text-align: right;
  }
</style>
